import angular from 'angular'
import './challenges.service'
import './edit/edit.controller'

angular
  .module('admin.challenges', ['admin.challenges.edit', 'admin.challenges.service'])
  .controller('ChallengesCtrl', ChallengesCtrl)

/** @ngInject */
function ChallengesCtrl(
  $scope,
  $state,
  $stateParams,
  $timeout,
  ChallengesService,
  ShelfieElementsService,
  CsvService,
) {
  var vm = this
  vm.challengesDraft = []
  vm.challengesActive = []
  vm.challengesArchive = []
  vm.msgErrorBool = false
  vm.sortType = 'id-desc'
  vm.sortReverse = false
  vm.sortType2 = 'id-desc'
  vm.sortReverse2 = false
  vm.sortType3 = 'id-desc'
  vm.sortReverse3 = false

  function reloadPaginationDraft() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationActive() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.perPage2 = 25
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchive() {
    vm.totalUsers3 = 0
    vm.oldPage3 = 0
    vm.perPage3 = 25
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  var tab = localStorage.getItem('challenges_tab')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#active').removeClass('active')
      $('#archive').removeClass('active')
      $('#draft').addClass('active')
      $('#draftTab').addClass('active')
    } else if (tab === 'active') {
      $('#draft').removeClass('active')
      $('#archive').removeClass('active')
      $('#active').addClass('active')
      $('#activeTab').addClass('active')
    } else if (tab === 'archive') {
      $('#active').removeClass('active')
      $('#draft').removeClass('active')
      $('#archive').addClass('active')
      $('#archiveTab').addClass('active')
    }
  } else {
    $('#active').addClass('active')
    $('#activeTab').addClass('active')
    localStorage.setItem('challenges_tab', 'active')
  }

  vm.tabDraft = function() {
    $('#active').removeClass('active')
    $('#archive').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('challenges_tab', 'draft')
  }

  vm.tabActive = function() {
    $('#draft').removeClass('active')
    $('#archive').removeClass('active')
    $('#active').addClass('active')
    localStorage.setItem('challenges_tab', 'active')
  }

  vm.tabArchive = function() {
    $('#draft').removeClass('active')
    $('#active').removeClass('active')
    $('#archive').addClass('active')
    localStorage.setItem('challenges_tab', 'archive')
  }

  reloadPaginationDraft()
  reloadPaginationActive()
  reloadPaginationArchive()
  loadDraft(1)
  loadActive(1)
  loadArchive(1)

  var oldSortType
  function loadDraft(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }
    oldSortType = angular.copy(vm.sortType)
    ChallengesService.list(vm.oldPage, 25, vm.sortType).then(function(result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-start'] !== undefined && items[i]['ts-start'] !== null) {
          items[i]['ts-start'] = new Date(
            parseInt(
              items[i]['ts-start']
                .toString()
                .substring(0, items[i]['ts-start'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-end'] !== undefined && items[i]['ts-end'] !== null) {
          items[i]['ts-end'] = new Date(
            parseInt(
              items[i]['ts-end'].toString().substring(0, items[i]['ts-end'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-p'] !== undefined && items[i]['ts-p'] !== null) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
      }

      vm.sortType = oldSortType
      vm.challengesDraft = items
    })
  }

  var oldSortType2
  function loadActive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }
    oldSortType2 = angular.copy(vm.sortType2)
    ChallengesService.listActive(vm.oldPage2, 25, vm.sortType2).then(function(result) {
      var items = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-start'] !== undefined && items[i]['ts-start'] !== null) {
          items[i]['ts-start'] = new Date(
            parseInt(
              items[i]['ts-start']
                .toString()
                .substring(0, items[i]['ts-start'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-end'] !== undefined && items[i]['ts-end'] !== null) {
          items[i]['ts-end'] = new Date(
            parseInt(
              items[i]['ts-end'].toString().substring(0, items[i]['ts-end'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-p'] !== undefined && items[i]['ts-p'] !== null) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
      }

      vm.sortType2 = oldSortType2
      vm.challengesActive = items
    })
  }

  var oldSortType3
  function loadArchive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }
    oldSortType3 = angular.copy(vm.sortType3)
    ChallengesService.listArchive(vm.oldPage3, vm.currentPage3, vm.sortType3).then(function(
      result,
    ) {
      var items = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-start'] !== undefined && items[i]['ts-start'] !== null) {
          items[i]['ts-start'] = new Date(
            parseInt(
              items[i]['ts-start']
                .toString()
                .substring(0, items[i]['ts-start'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-end'] !== undefined && items[i]['ts-end'] !== null) {
          items[i]['ts-end'] = new Date(
            parseInt(
              items[i]['ts-end'].toString().substring(0, items[i]['ts-end'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-p'] !== undefined && items[i]['ts-p'] !== null) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
      }

      vm.sortType3 = oldSortType3
      vm.challengesArchive = items
    })
  }

  vm.pageChangedDraft = function(newPage) {
    vm.sortType = oldSortType
    loadDraft(newPage)
  }

  vm.pageChangedActive = function(newPage) {
    vm.sortType2 = oldSortType2
    loadActive(newPage)
  }

  vm.pageChangedArchive = function(newPage) {
    vm.sortType3 = oldSortType3
    loadArchive(newPage)
  }

  vm.add = function() {
    vm.title = null
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function() {
      $('#inputChallenge').focus()
    })
  }

  vm.edit = function(item) {
    $state.go('admin.challenges.edit', { id: item.id })
  }

  vm.saveChallenge = function() {
    if (vm.title === '' || vm.title === undefined) {
      vm.msgError = 'Title: non zero value required'
      vm.msgErrorBool = true
      return
    }
    if (vm.title.length <= 2) {
      vm.msgError = 'Title: needs at least 3 characters'
      vm.msgErrorBool = true
      return
    }
    if (vm.hashtag === '' || vm.hashtag === undefined) {
      vm.msgError = 'Hashtag: non zero value required'
      vm.msgErrorBool = true
      return
    } else {
      if (vm.hashtag.indexOf('QC-') === -1) {
        vm.hashtag = 'QC-' + vm.hashtag
      }
    }
    $('#myModal').modal('hide')
    $('#myModal').on('hidden.bs.modal', function() {
      ChallengesService.save({ t: vm.title, h: vm.hashtag }).then(
        function(result) {
          $state.go('admin.challenges.edit', { id: result.results.id })
        },
        function(err) {
          $timeout(function() {
            swal(err.error.message, '', 'error')
          }, 500)
        },
      )
    })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChallengesService.remove(item.id).then(
            function() {
              loadDraft(1)
              loadActive(1)
              loadArchive(1)
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        }
      },
    )
  }

  vm.publish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChallengesService.publish(item.id).then(
            function() {
              loadDraft(1)
              loadActive(1)
              loadArchive(1)
            },
            function(err) {
              $timeout(function() {
                swal(
                  'Challenge details are incomplete! Please edit before publishing.',
                  '',
                  'error',
                )
              }, 500)
            },
          )
        }
      },
    )
  }

  vm.exportCsv = function(item) {
    CsvService.validSafari()

    ChallengesService.listWinners(item.id).then(function(result) {
      var winners = result.results
      var items = []

      for (var i = 0; i < winners.length; i++) {
        items.push({
          user_id: winners[i]['id-u'],
          username: winners[i].u.username,
          challenge_id: item.id,
          challenge_name: item.t,
        })
      }

      var csv = CsvService.convertArrayOfObjectsToCSV({
        data: items,
      })

      if (csv === null) {
        return
      }

      if (CsvService.isSafari() || CsvService.isFirefox()) {
        var link = document.createElement('a')
        link.id = 'csvDwnLink'

        document.body.appendChild(link)
        window.URL = window.URL || window.webkitURL
        var csv2 = '\ufeff' + csv,
          csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
          filename = item.t + '.csv'
        $('#csvDwnLink').attr({ download: item.t, href: csvData })
        $('#csvDwnLink')[0].click()
        document.body.removeChild(link)
      } else {
        var filename = item.t + '.csv'

        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv
        }

        var data = encodeURI(csv)
        var link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', item.t)
        link.click()
      }
    })
  }
}
